export const ETSCols = (feature: boolean) => {
    return [{ 
    headerClassName: 'data-table header fixedNumber',
    className: 'fixedNumber',
    show: true,
    accessor: 'etsNumber',
    isActionLink: true,
    id: 'etsNumber-col-link',
    fieldHeader: 'ETS number',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: feature,
    accessor: 'productType',
    id: 'productType-col',
    fieldHeader: 'Product Type',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'cblStatus',
    id: 'cbl-status-col',
    fieldHeader: 'CBL Status',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'finOpsStatus',
    id: 'status-col',
    fieldHeader: 'Finops Status',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'equipmentNumber',
    id: 'equipmentNumber-col',
    fieldHeader: 'Equipment Number',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'cblNumber',
    id: 'cblNumber-col',
    fieldHeader: 'CBL Number',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'sapsoNumber',
    id: 'sapsoNumber-col',
    fieldHeader: 'SAP SO. Number',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'source',
    id: 'source-col',
    fieldHeader: 'Source',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'originService',
    id: 'originService-col',
    fieldHeader: 'Origin / Destination Service',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'consigneeBECode',
    id: 'consignee-col',
    fieldHeader: 'Consignee',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'shipperBECode',
    id: 'shipper-col',
    fieldHeader: 'Shipper',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'contractualParty',
    id: 'contractualParty-col',
    fieldHeader: 'Contractual Party',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'carrierCode',
    id: 'carrier-col',
    fieldHeader: 'Carrier Code',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'salesOrg',
    id: 'salesOrg',
    fieldHeader: 'Sales Organization',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'jobCreationDate',
    id: 'jobCreationDate-col',
    fieldHeader: 'Job Creation Date',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'eta',
    id: 'eta-col',
    fieldHeader: 'ETA',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'etd',
    id: 'etd-col',
    fieldHeader: 'ETD',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangedBy',
    id: 'lastChangedBy-col',
    fieldHeader: 'Last Changed By',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'lastChangeDate',
    id: 'lastChangeDate-col',
    fieldHeader: 'Last Change Date',
    sortable: true
},  
{ 
    headerClassName: 'data-table header',
    show: false,
    accessor: 'id',
    id: 'eq-id-col',
    fieldHeader: 'ID',
    sortable: true
},
{
    headerClassName: 'data-table header no-sorting',
    show: true,
    accessor: 'agedTime',
    id: 'agedInHrs',
    fieldHeader: 'Aging (Hours)',
    sortable: false
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'placeOfReceipt',
    id: 'placeOfReceipt-col',
    fieldHeader: 'Place of Receipt',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'portOfLoading',
    id: 'portOfLoading-col',
    fieldHeader: 'Port of Loading',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'portOfDischarge',
    id: 'portOfDischarge-col',
    fieldHeader: 'Port Of Discharge',
    sortable: true
},
{ 
    headerClassName: 'data-table header',
    show: true,
    accessor: 'placeOfDelivery',
    id: 'placeOfDelivery-col',
    fieldHeader: 'Place of Delivery',
    sortable: true
},
{
    headerClassName: 'data-table header no-sorting',
    show: true,
    className: 'overflowVisible',
    accessor: 'rateErrorMessage',
    id: 'errorMessage',
    fieldHeader: 'Error Message',
    sortable: false
}]}